import { render, staticRenderFns } from "./BaseQuickAdd.vue?vue&type=template&id=e6272cc0&scoped=true"
import script from "./BaseQuickAdd.vue?vue&type=script&lang=js"
export * from "./BaseQuickAdd.vue?vue&type=script&lang=js"
import style0 from "./BaseQuickAdd.vue?vue&type=style&index=0&id=e6272cc0&prod&lang=css"
import style1 from "./BaseQuickAdd.vue?vue&type=style&index=1&id=e6272cc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6272cc0",
  null
  
)

export default component.exports